<template>
    <div
        class="custom-create-form-wrapper"
        id="parent-register-form">
        <div class="custom-create-form">
            <custom-form-create-header-component
                title="Formulier verstuurd"
                logo="/images/amsterdams-lyceum-logo.png"
                bg-color="#0062ab"
                title-color="#fff">
            </custom-form-create-header-component>
        </div>

        <div class="custom-form-create-body">
            {{$t('common.thank_you_for_completing_the_form_you_can_close_this_window')}}
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import {ords} from "../../../app";

export default {
    name: "custom-form-finished-component",
    data() {
        return{
        }
    },
}

</script>

<style scoped lang="scss">
    ::v-deep .main-content {
        margin-bottom: 0;
    }

    .custom-form-create-body {
        padding: map-get($grid-gutter-spacing, 'twenty-one');
        height: calc(100vh - 408px);
        font-size: 1.125rem;
        font-weight: $font-weight-medium;
        color: $text-muted-color;
    }

    @media (min-width: map-get($grid-breakpoints, 'sm')) {
        .custom-form-create-body {
            height: calc(100vh - 316px);
        }
    }

    @media (min-width: map-get($grid-breakpoints, 'md')) {
        .custom-form-create-body {
            height: calc(100vh - 321px);
        }
    }

    @media (min-width: map-get($grid-breakpoints, 'xxl')) {
        .custom-form-create-body {
            height: calc(100vh - 285px);
        }
    }
</style>
